import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WebDateTimePickerComponent } from './web-date-time-picker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TranslateModule } from '@ngx-translate/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        PopoverModule.forRoot(),
        TimepickerModule.forRoot(),
        BsDatepickerModule,
        FormsModule,
        TranslateModule,
        WebDateTimePickerComponent,
    ],
    exports: [WebDateTimePickerComponent],
})
export class WebDateTimePickerModule {}
